export const inspectTable = [
  {
    title: '산업안전보건법',
    content: `고압실 내 작업(잠함공법이나 그 밖의 압기공법으로 대기압을 넘는 기압인 작업실 또는 수갱 내부에서 하는 작업만 해당한다)`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `아세틸렌 용접장치 또는 가스집합 용접장치를 사용하는 금속의 용접·용단 또는 가열작업(발생기·도관 등에 의하여 구성되는 용접장치만 해당한다)`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `밀폐된 장소(탱크 내 또는 환기가 극히 불량한 좁은 장소를 말한다)에서 하는 용접작업 또는 습한 장소에서 하는 전기용접 작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `폭발성·물반응성·자기반응성·자기발열성 물질, 자연발화성 액체·고체 및 인화성 액체의 제조 또는 취급작업(시험연구를 위한 취급작업은 제외한다)`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `액화석유가스·수소가스 등 인화성 가스 또는 폭발성 물질 중 가스의 발생장치 취급 작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `화학설비 중 반응기, 교반기·추출기의 사용 및 세척작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `화학설비의 탱크 내 작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `분말·원재료 등을 담은 호퍼(하부가 깔대기 모양으로 된 저장통)·저장창고 등 저장탱크의 내부작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `다음 각 목에 정하는 설비에 의한 물건의 가열·건조작업
    <span style="font-weight: 400;">가. 건조설비 중 위험물 등에 관계되는 설비로 속부피가 1세제곱미터 이상인 것</span>
    <span style="font-weight: 400;">나. 건조설비 중 가목의 위험물 등 외의 물질에 관계되는 설비로서, 연료를 열원으로 사용하는 것(그 최대연소소비량이 매 시간당 10킬로그램 이상인 것만 해당한다) 또는 전력을 열원으로 사용하는 것(정격소비전력이 10킬로와트 이상인 경우만 해당한다)</span>`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `다음 각 목에 해당하는 집재장치(집재기·가선·운반기구·지주 및 이들에 부속하는 물건으로 구성되고, 동력을 사용하여 원목 또는 장작과 숯을 담아 올리거나 공중에서 운반하는 설비를 말한다)의 조립, 해체, 변경 또는 수리작업 및 이들 설비에 의한 집재 또는 운반 작업
    <span style="font-weight: 400;">가. 원동기의 정격출력이 7.5킬로와트를 넘는 것</span>
    <span style="font-weight: 400;">나. 지간의 경사거리 합계가 350미터 이상인 것</span>
    <span style="font-weight: 400;">다. 최대사용하중이 200킬로그램 이상인 것</span>
`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `동력에 의하여 작동되는 프레스기계를 5대 이상 보유한 사업장에서 해당 기계로 하는 작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `목재가공용 기계[둥근톱기계, 띠톱기계, 대패기계, 모떼기기계 및 라우터기(목재를 자르거나 홈을 파는 기계)만 해당하며, 휴대용은 제외한다]를 5대 이상 보유한 사업장에서 해당 기계로 하는 작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `운반용 등 하역기계를 5대 이상 보유한 사업장에서의 해당 기계로 하는 작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `1톤 이상의 크레인을 사용하는 작업 또는 1톤 미만의 크레인 또는 호이스트를 5대 이상 보유한 사업장에서 해당 기계로 하는 작업(제40호의 작업은 제외한다)`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `건설용 리프트·곤돌라를 이용한 작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `주물 및 단조(금속을 두들기거나 눌러서 형체를 만드는 일) 작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `전압이 75볼트 이상인 정전 및 활선작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `콘크리트 파쇄기를 사용하여 하는 파쇄작업(2미터 이상인 구축물의 파쇄작업만 해당한다)`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `굴착면의 높이가 2미터 이상이 되는 지반 굴착(터널 및 수직갱 외의 갱 굴착은 제외한다)작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `흙막이 지보공의 보강 또는 동바리를 설치하거나 해체하는 작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `터널 안에서의 굴착작업(굴착용 기계를 사용하여 하는 굴착작업 중 근로자가 칼날 밑에 접근하지 않고 하는   작업은 제외한다) 또는 같은 작업에서의 터널 거푸집 지보공의 조립 또는 콘크리트 작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `굴착면의 높이가 2미터 이상이 되는 암석의 굴착작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `높이가 2미터 이상인 물건을 쌓거나 무너뜨리는 작업(하역기계로만 하는 작업은 제외한다)`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `선박에 짐을 쌓거나 부리거나 이동시키는 작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `거푸집 동바리의 조립 또는 해체작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `비계의 조립·해체 또는 변경작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `건축물의 골조, 다리의 상부구조 또는 탑의 금속제의 부재로 구성되는 것(5미터 이상인 것만 해당한다)의   조립· 해체 또는 변경작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `처마 높이가 5미터 이상인 목조건축물의 구조 부재의 조립이나 건축물의 지붕 또는 외벽 밑에서의 설치작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `콘크리트 인공구조물(그 높이가 2미터 이상인 것만 해당한다)의 해체 또는 파괴작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `타워크레인을 설치(상승작업을 포함한다)·해체하는 작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `보일러(소형 보일러 및 다음 각 목에서 정하는 보일러는 제외한다)의 설치 및 취급 작업
    <span style="font-weight: 400;">가. 몸통 반지름이 750밀리미터 이하이고 그 길이가 1,300밀리미터 이하인 증기보일러</span>
    <span style="font-weight: 400;">나. 전열면적이 3제곱미터 이하인 증기보일러</span>
    <span style="font-weight: 400;">다. 전열면적이 14제곱미터 이하인 온수보일러</span>
    <span style="font-weight: 400;">라. 전열면적이 30제곱미터 이하인 관류보일러(물관을 사용하여 가열시키는 방식의 보일러)</span>
`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `게이지 압력을 제곱센티미터당 1킬로그램 이상으로 사용하는 압력용기의 설치 및 취급작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `방사선 업무에 관계되는 작업(의료 및 실험용은 제외한다)`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `밀폐공간에서의 작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `허가 및 관리 대상 유해물질의 제조 또는 취급작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `로봇작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `석면해체·제거작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `가연물이 있는 장소에서 하는 화재위험작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
  {
    title: '산업안전보건법',
    content: `타워크레인을 사용하는 작업시 신호업무를 하는 작업`,
    rowType: 'customType',
    customIndex: [0, 1],
    isChecked: ``,
  },
];
